// IMPORTANT: this is a plugin which requires jQuery for initialisation and data manipulation

import { Component, OnInit, ElementRef, Inject, AfterViewInit,AfterViewChecked } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';


import { FolderPermissionCompanyService } from '../../services/folderpermissioncompany.service';
import { FileCompanyService } from '../../services/filecompany.service';
import { Filecompany } from '../../models/filecompany';
import { FolderCompanyService } from '../../services/foldercompany.service';
import { Foldercompany } from '../../models/foldercompany';

import { Observable } from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import swal from 'sweetalert2';

import { DomSanitizer } from '@angular/platform-browser';


declare const require: any;

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare const $: any;

interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage(): string;
}

export interface UserList {
  value: string;
  name: string;
}

@Component({
    selector: 'app-listshowfilescompany-cmp',
    templateUrl: 'listshowfilescompany.component.html',
    styleUrls: ['./file-upload.component.scss'],
    providers: [UserService, FileCompanyService, FolderCompanyService, FolderPermissionCompanyService]
})

export class ListshowfilescompanyComponent implements OnInit, AfterViewInit,AfterViewChecked  {
 public advancedsearchtext;
  name: string;
    public tableFolder;
  animal: string;
  public dataTable: DataTable;
  public dataFolder: DataTable;
  public dataTableSearch: DataTable;
  public dataTablePOSearch: DataTable;
  public privilegio;
  public showsearchResults = 0;
  sexos = [
      {value: '1', viewValue: 'Hombre'},
      {value: '0', viewValue: 'Mujer'}
    ];
    public showMsgSearchingNotResults = 0;
  public pacientes: Array<User>;
  public files: Array<Filecompany>;
  public folder: Array<Foldercompany>;
  public permissions: any;
  public identity;
  public token;
  public endpointType = 'traditional'; // 's3' or 'traditional'
  public cloudFrontUrl = '';
  public pages;
  public pagePrev;
  public pageNext;
  public filter = 0;
  public order = 0;
  public searchString;
  public hasparent = 0;
  public user;
  public typeFolders;
public folderinterno = {
  "name" : "",
  "folderPath": ""
}
  ;
public folderNew;
  public file;
  public userlogged;
  public status_user;
  selectedFile: File;
  public idFolder;
  public folderPermissions;
  public permissionsShow;
  public idOwner;
  public uploadData = new FormData();
  public stringPath = "/";
  public sanitizerGlobal: DomSanitizer;
  public fullPermission = 0;
  public contarFolders = 0;
  public contarFiles = 0;
  public companyId;
    myControl = new FormControl();
  myControlClientes = new FormControl();
  public showsearch = 0;
  public isOwner = false;
  public apiCompany;

  public urlUpload: any = 'https://www.greenteksolutions.com/loading1.gif';
   
   clientes: UserList[] = [
       
  ];
  
 
   filteredClientes: Observable<UserList[]>;

// State for dropzone CSS toggling
  isHovering: boolean;

  public loading: boolean = false;

  constructor(public dialog: MatDialog,private _route: ActivatedRoute,
    private _router: Router,
    private _userService: UserService,
    private _fileService: FileCompanyService,
    private _folderService: FolderCompanyService,
    private _folderPermissionService: FolderPermissionCompanyService,
     public sanitizer: DomSanitizer
    ) {
    this.sanitizerGlobal = sanitizer;
    this.folderPermissions = new Foldercompany(1, '', '', '',0,'',1,0,1,0);
  this.folderPermissions.permissions =  [];
   this.permissionsShow = [];
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

   if(this.token){
    this._userService.getUser(this.token, this.identity.sub).subscribe(
        response => {
          console.log(response);
          if(response.status == 'success'){
           
              this.userlogged = response.data;
             

              this.apiCompany = this.userlogged.companyLinked.apiToken;
              console.log(this.apiCompany);
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
        },
        error => {
          console.log(<any>error);
        }
      );
   }

    if(this.privilegio.level == 'ADMINISTRATOR' || this.privilegio.level == 'MANAGER' 

   //  || this.privilegio.level == 'PURCHASINGREP' 
    // ||  this.privilegio.level == 'worker'
     ){
              this.fullPermission = 1;
            }

    if(this.identity == null && this.identity.sub){
      localStorage.clear();
      this._router.navigate(['/pages/lock']);
    } else {


    } 

  /*this._route.params.subscribe(val => {
    // put the code from `ngOnInit` here
    console.log("subscribe route fired!");

  })*/

  }



  showsrch(){
    if(this.showsearch)
      this.showsearch = 0;
    else
      this.showsearch = 1;
  }

public showposearch = 0;
public advancedpotext = '';

  showposrch(){
    if(this.showposearch)
      this.showposearch = 0;
    else
      this.showposearch = 1;
  }

searchAdvanced(){
  $("#showMsgSearching").show();
  this.dataTableSearch.dataRows = [];
  this.showMsgSearchingNotResults = 0;
 
  this._fileService.searchBetweenFiles(this.privilegio.sub, this.idFolder, this.advancedsearchtext). subscribe(
        response =>{
          $("#showMsgSearching").hide();
        //  console.log(response);
          //console.log(response.length);
          if(response.length > 0){
            this.showsearchResults = 1;
           this.showMsgSearchingNotResults = 0;
          }else{
            this.showsearchResults = 0;
            this.showMsgSearchingNotResults = 1;
          }
         response.forEach(function(element) {
         // console.log(element.file);
          this.dataTableSearch.dataRows.push([element.idfile, element.filename, element.idFolderDB, '']);
        }.bind(this));        },
        error => {
          console.log(<any>error);
        }
        ); 
}

public showMsgPOSearchingNotResults = 0;
public showsearchPOResults = 0;

searchPO(){
  $("#showMsgPOSearching").show();
  this.dataTablePOSearch.dataRows = [];
  this.showMsgPOSearchingNotResults = 0;

 
  this._fileService.searchPO(this.privilegio.sub, this.advancedpotext). subscribe(
        response =>{
          $("#showMsgPOSearching").hide();
         // console.log(response);
          console.log(response.length);
          if(response.length > 0){
            this.showsearchPOResults = 1;
           this.showMsgPOSearchingNotResults = 0;
          }else{
            this.showsearchPOResults = 0;
            this.showMsgPOSearchingNotResults = 1;
          }
         response.forEach(function(element) {
        //  console.log(element.file);
          this.dataTablePOSearch.dataRows.push([element.id, element.folderName, '']);
        }.bind(this));        },
        error => {
          console.log(<any>error);
        }
        ); 
}

  ngOnInit(){
   // console.log("6666");
   // console.log("ngOnInit fired!");
       let intentos = 0;     
//do{
          //this.getFolderInfo();

          //inicio params
    this._route.params.forEach((params: Params) => {
      let id =+ params['id'];
 let page = 1;
 this.idFolder = id;
 console.log("iniciamos");
   
      let parent = this.idFolder;

      if(
        this.privilegio.level == 'ADMINISTRATOR'   || this.privilegio.level == 'MANAGER' 
        //|| this.privilegio.level == 'PURCHASINGREP'  
        //|| this.privilegio.level == 'worker'
        ){
        this.typeFolders = 'ALL';
      this.isOwner = true;
      } /*else if(this.privilegio.level == 'worker'){
        this.typeFolders = 'ALL';
      } */ else {
        this.typeFolders = 'USER';
      }

      this.loading = true;
      this.contarFolders = 0;

    //1-inicio getFolder
     let varinicio = this.inicioGetFolder();
     
//1-fin getFolder
    

    

      //2-inicia getSubFolders
      //  let varsegundo=  this.segundogetSubFolders();
     //console.log("varsegundo: " + varsegundo);
      //2-fin getSubFolders

//3- obtenemos permisos del folder
this._folderPermissionService.getFolder(this.token, id). subscribe(
        response =>{
          console.log("3- get permisos");
         // console.log(response);
         
          if(response.status == 'success'){
          
           this.permissions = response.data;

           
          
          } 
        },
        error => {
          console.log(<any>error);
        }
        );  
//3- fin permisos del folder

    });
// fin params

       
 
  
intentos++;
//}while(this.folderinterno == null && intentos <3);

    this.dataTableSearch = {
            headerRow: [ 'File Name','Actions' ],
            footerRow: ['File Name' ,'Actions' ],

            dataRows: [
               
            ]
         };

         this.dataTablePOSearch = {
            headerRow: [ 'Folder Name','Actions' ],
            footerRow: ['Folder Name' ,'Actions' ],

            dataRows: [
               
            ]
         };
  }

    toggleHover(event: boolean) {
    this.isHovering = event;
  }

  deletePermiso(permiso){
    this.loading = true;
    let me = this;
    swal.fire({
                    title: 'Are you sure?',
                    text: 'You are going to delete this permission.',
                
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, keep it',

               
                     customClass:{
    confirmButton: 'btn btn-danger',
    cancelButton: 'btn btn-success',
            },
                    buttonsStyling: false
                }).then(function(request) {
                  if(request.value == true){
                    me._folderPermissionService.delete(me.token, permiso.id).subscribe(
      response =>{
                  if(response.status == 'success'){
                    //this._router.navigate(['/']);
                 $("#permi-"+permiso.id).hide();
                  // this.getFiles(this.idFolder);
                  console.log("deleted");
                   swal.fire({
                                  title: 'Deleted!',
                                  text: 'Permission has been deleted.',
                                
                                 customClass:{
    confirmButton: 'btn btn-success'
            },
                                  buttonsStyling: false
                              });
                  me.loading = false;
                  } 
                },
      error => {
        console.log(<any>error);
         alert("Error");
      }
      );

                   
                  } else {
                    me.loading = false;
                      swal.fire({
                          title: 'Cancelled',
                          text: '',
                       
            
                           customClass:{
    confirmButton: 'btn btn-info'
            },
                          buttonsStyling: false
                      });
                  }
                  
                });
   

    
  }

    openNuevoFolder(): void {
      this.folderNew = new Foldercompany(1, '', '', '',0,'',this.idFolder,0,1, this.companyId);
     // console.log(this.companyId);
      console.log(this.folderNew);
    let dialogRef = this.dialog.open(NewSubFoldercompanyFiles, {
      width: '80%',
        data: { folder: this.folderNew, folderParent: this.idFolder}
    });

    dialogRef.afterClosed().subscribe(result => {
    //  result.folder.user_id = result.user_id.value;
    //  console.log(result);
      //console.log(result.folder);
      
     this._folderService.create(this.token, result).subscribe(
        response => {
          console.log(response);
          this.status_user = response.status;

          if(this.status_user != 'success'){
            this.status_user = 'error';
          } else {
           this.showSwal('success-message');
      //this.animal = result;
      this.getAllPacientes();
          this.contarFolders++;
          }
        },
        error => {
          console.log(<any>error);
        }
      );
    
    });
  }


  public async segundogetSubFolders(){
    this.loading = true;
    let response = await this._folderService.getSubFolders(this.token, 1, this.typeFolders, this.idFolder). subscribe(
        response =>{
          console.log("2- get subfolder");
          //console.log(response);
          if(response.status == 'success'){
            this.pacientes = response.data;
           
             this.dataFolder = {
            headerRow: ['Type', 'ID', 'Folder Name', 'User','Actions', 'Last Updated' ],
            footerRow: ['Type', 'ID','Folder Name', 'User' ,'Actions', 'Last Updated' ],

            dataRows: [
               
            ]
         };
        


          this.dataFolder.dataRows = [];
          if( this.typeFolders == 'ALL'){
            console.log("if1");
            this.pacientes.forEach(function(element) {
              console.log(element);
             this.contarFolders++;

             if(isNaN(element.name)){
              console.log("isNaN");
                  this.dataFolder.dataRows.push([element.id, element.name, element.user.name + ' ' + element.user.surname, '', element.createdAt.timestamp * 1000]);
             }else{
              this.dataFolder.dataRows.push([element.id, element.name, element.user.name + ' ' + element.user.surname, '', element.createdAt.timestamp * 1000]);
/*
               console.log("isN");
                let params = "authorization="+this.token;
    let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest'});
    let page =1;
    if(page == null){
      page = 1;
    }

             let responsefolder =  this._http.post('https://www.greenteksolutions.com/web/cita/getprocessingbyponumber/'+element.name+'?page='+page, params, {headers: headers})
                          .map(res => res.json()).subscribe(result => {

                            this.dataFolder.dataRows.push([element.id, element.name, element.user.name + ' ' + element.user.surname, '', element.createdAt.timestamp * 1000]);
                           
     // console.log(result.data.timestamp * 1000);
    //  return result.data.timestamp * 1000;
    if(result.data){
      this.dataFolder.dataRows.push([element.id, element.name, element.user.name + ' ' + element.user.surname, '', result.data.timestamp * 1000]);
    }
    else {
      this.dataFolder.dataRows.push([element.id, element.name, element.user.name + ' ' + element.user.surname, '', element.createdAt.timestamp * 1000]);
    }
      
    });*/
             }
              
            }.bind(this));
          } else {
            this.pacientes.forEach(function(element) {
              console.log(element);
            console.log("if2");
             this.contarFolders++;
             this.dataFolder.dataRows.push([element.id, element.name, element.user.name + ' ' + element.user.surname, '', element.createdAt]);
             // this.dataFolder.dataRows.push([element.folderList.id, element.folderList.name, element.folderList.user.name + ' ' + element.folderList.user.surname, '']);
            }.bind(this));
          } 

            
         
          
            this.loading = false;
            //this.getFiles(this.idFolder);
            console.log("2- permiso " + this.fullPermission);
            // inicio fullPermission
    if(this.fullPermission == 1){
      console.log("2- entramos full permission "+ this.idFolder);
      this.contarFiles=0;
      // inicio getFilesFolder
     this._fileService.getFilesFolder(this.token, this.idFolder). subscribe(
        response =>{
          console.log("2- get filesfolder");
         // console.log(response);
          if(response.status == 'success'){
        
           

  this.dataTable = {
            headerRow: ['ID', 'Report Name', 'Created at','Actions' ],
            footerRow: ['ID', 'Report Name', 'Created at' ,'Actions' ],

            dataRows: [
               
            ]
         };

         this.dataTable.dataRows = [];


            response.data.forEach(function(element) {
             this.contarFiles++;
              this.dataTable.dataRows.push([element.id, element.file, element.createdAt, '']);
            }.bind(this));
          
          
          } 
        },
        error => {
          console.log(<any>error);
        }
        );  
     // fin getFilesFolder

   } else{
    console.log("no entramos");
   }
   // fin fullPermission
           

           
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
        }
        ); 

    return response;
  }

  doRefresh(){
     window.location.reload();
  }


   async inicioGetFolder(){
    //inicioGetFolder = async() => {
    let responsefolder = await this._folderService.getFolder(this.token, this.idFolder)
  .toPromise()
  .then(response =>{
          console.log("1- get folder");
          console.log(response);
         //inicia success
          if(response.status == 'success'){
            this.folderinterno = response.data;
            this.companyId = response.data.companyId;
          //  console.log("companyId "+ this.companyId);

           if(this.identity.sub == response.data.user.id){
              this.isOwner = true;
             this.typeFolders = 'ALL';
           }
            
            this.hasparent = response.data.hasParent;

            if(
              this.privilegio.level == 'ADMINISTRATOR' || this.privilegio.level == 'MANAGER'  || this.isOwner == true
              // || this.privilegio.level == 'worker'  
              // || this.privilegio.level == 'PURCHASINGREP'
               ){

     this.getListUsers(this.companyId);
     console.log("1- postgestlisusers");
    this.filteredClientes = this.myControlClientes.valueChanges
      .pipe(
        startWith<string | UserList>(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filterClientes(name) : this.clientes.slice())
      );

      console.log(this.filteredClientes);
      console.log(this.clientes);
  }

            if(
              this.privilegio.level == 'ADMINISTRATOR' || this.privilegio.level == 'MANAGER'  || this.isOwner == true
              // || this.privilegio.level == 'worker'  
              // || this.privilegio.level == 'PURCHASINGREP'
               ){
              this.fullPermission = 1;

             
            }else {
             this.fullPermission = response.permission.fullPermission
             console.log(this.fullPermission);
               
            
            }
             this.urlUpload = 'https://itaderp.com/script-uploadcompany/dashboard-upload.php?idfolder=' + this.idFolder+'&idowner='+this.identity.sub+'&apikey='+this.apiCompany;

// this.urlUpload = sanitizer.bypassSecurityTrustResourceUrl('https://itaderp.com/script-upload/dashboard-upload.php?idfolder=' + this.idFolder);
this.urlUpload = this.sanitizerGlobal.bypassSecurityTrustResourceUrl(this.urlUpload);
      
      console.log("1- acabamos");
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }

          return this.fullPermission;
        },
        error => {
          console.log(<any>error);
        }
        );  
     if(await typeof responsefolder !== 'undefined' ){

        console.log(responsefolder);
         //2-inicia getSubFolders
        let varsegundo=  this.segundogetSubFolders();
     console.log("varsegundo: " + varsegundo);
      //2-fin getSubFolders
     }
    
  }

  getAllPacientes(){

    this._route.params.forEach((params: Params) => {
      let page =+ params['page'];

      if(!page){
        page = 1;
      }

  
      let parent = this.idFolder;

      if(this.privilegio.level == 'ADMINISTRATOR' || this.privilegio.level == 'MANAGER'  || this.isOwner == true
      // || this.privilegio.level == 'PURCHASINGREP'  
      // || this.privilegio.level == 'worker'
       ){
        this.typeFolders = 'ALL';
      } /*else if(this.privilegio.level == 'worker'){
        this.typeFolders = 'ALL';
      } */ else {
        this.typeFolders = 'USER';
      }

      this.loading = true;
      this._folderService.getSubFolders(this.token, page, this.typeFolders, parent). subscribe(
        response =>{
          console.log(response);
          if(response.status == 'success'){
            this.pacientes = response.data;
           
            


          this.dataFolder.dataRows = [];
          if( this.typeFolders == 'ALL'){
            this.pacientes.forEach(function(element) {
             
              this.dataFolder.dataRows.push([element.id, element.name, element.user.name + ' ' + element.user.surname, '']);
            }.bind(this));
          } else {
            this.pacientes.forEach(function(element) {
             
              this.dataFolder.dataRows.push([element.folderList.id, element.folderList.name, element.folderList.user.name + ' ' + element.folderList.user.surname, '']);
            }.bind(this));
          } 

            
         
          
            this.loading = false;
            this.getFiles(this.idFolder);

            //total paginas
            this.pages = [];
            for(let i = 0; i < response.total_pages; i++){
              this.pages.push(i);
            }

            //pagina anterior
            if(page >= 2){
              this.pagePrev = (page - 1);

            } else {
              this.pagePrev = page;
            }

            //pagina siguiente
            if(page < response.total_pages){
              this.pageNext = (page+1); 
            } else {
              this.pageNext = page;
            }
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
        }
        );  
    });
  }




  
deleteFolder(){
    this.loading = true;
    let id = $( "#borrarFolder" ).val();
    console.log(id + "aqui");
    this._folderService.deleteFolder(this.token, id).subscribe(
      response =>{
        if(response.status == 'success'){
          //this._router.navigate(['/']);
       alert("Done");
        // this.getFiles(this.idFolder);
        console.log("deleted");
        this.loading = false;
        } else {
          alert("Error");
        }
      },
      error => {
        console.log(<any>error);
         alert("Error");
      }
      );
  }



  deleteUser(){
    this.loading = true;
    let id = $( "#borrarUser" ).val();
    console.log(id + "aqui");
    this._fileService.deleteFile(this.token, id).subscribe(
      response =>{
        if(response.status == 'success'){
          //this._router.navigate(['/']);
        alert("Done");
        // this.getFiles(this.idFolder);
        console.log("deleted");
        this.loading = false;
        } else {
          alert("Error");
        }
      },
      error => {
        console.log(<any>error);
         alert("Error");
      }
      );
  }

showSwal(type) {
       if (type === 'success-message') {
            swal.fire({
             
                   title: 'Folder has been created',
                text: '',
                buttonsStyling: false,
               
 customClass:{
    confirmButton: 'btn btn-success'
            },

            });

        } else if (type === 'success-message-file') {
            swal.fire({
           
           
                 title: 'File uploaded!',
                text: 'your file has been successfully uploaded',
                buttonsStyling: false,
              
 customClass:{
    confirmButton: 'btn btn-success'
            },

            }).then(function(e) {
                  console.log(e);
                  this.getFiles(this.idFolder);
                });

        } else if (type === 'warning-message-and-confirmation') {
            swal.fire({
                    title: 'Are you sure?',
                    text: 'You will not be able to revert this!',
                
                    showCancelButton: true,
         
                    customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger',
            },

                    confirmButtonText: 'Yes, delete it!',
                    buttonsStyling: false
                }).then(function() {
                  swal.fire({
                    title: 'Deleted!',
                    text: 'Your file has been deleted.',
                   
      
                    customClass:{
    confirmButton: 'btn btn-success'
            },

                    buttonsStyling: false
                });
                });
            }
    }


    

  getFiles(folder){
    console.log("permiso " + this.fullPermission);
    if(this.fullPermission == 1 || this.isOwner == true){
      console.log("entramos");

     this._fileService.getFilesFolder(this.token, folder). subscribe(
        response =>{
          console.log(response);
          if(response.status == 'success'){
        
            this.dataTable.dataRows = [];




            response.data.forEach(function(element) {
             
              this.dataTable.dataRows.push([element.id, element.file, element.createdAt, '']);
            }.bind(this));
          
          
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
        }
        );  
   } else{
    console.log("no entramos");
   }
  }

  deleteFolderfirst(folder){
    var txt;
    var r = confirm("Are you sure to delete this folder?");
    if (r == true) {
        $("#folder"+folder).hide();
         $( "#borrarFolder" ).val(folder);
       
        $( "#borrarFolder" ).trigger( "click" );
    } else {
       
    }
  }

  deleteFile(file){
    
     
          
          var txt;
    var r = confirm("Are you sure to delete this file?");
    if (r == true) {
       $("#file"+file).hide();

         $( "#borrarUser" ).val(file);
       
        $( "#borrarUser" ).trigger( "click" );
    } else {
       
    }
        
       
     
  }

  downloadAll(){

      window.open("https://www.greenteksolutions.com/web/foldercompany/downloadall/"+this.idFolder+"/"+this.token, "_blank")
  }

  downloadFile(file){
        console.log(file);
      window.open("https://www.greenteksolutions.com/web/foldercompany/downloadfile/"+file+"/"+this.token, "_blank")
  }

openFile(idFile){
  console.log(idFile);

  this._fileService.getFile(this.token, idFile). subscribe(
        response =>{
          
          console.log(response);
          this.loading = false;
          if(response.status == 'success'){



            window.open("https://itaderp.com/script-uploadcompany"+
              response.data.folder+"/"+response.data.file, "_blank")
          

          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
        }
        );  

}


  getFolderInfo(){
    this._route.params.forEach((params: Params) => {
      let id =+ params['id'];
 let page = 1;
 this.idFolder = id;

    
      this._folderService.getFolder(this.token, id). subscribe(
        response =>{
          console.log(response);
         
          if(response.status == 'success'){
            this.folderinterno = response.data;
            this.idOwner = response.data.user.id;
            if(
              this.privilegio.level == 'ADMINISTRATOR' || this.privilegio.level == 'MANAGER'  || this.isOwner == true
             // || this.privilegio.level == 'worker' 
              // || this.privilegio.level == 'PURCHASINGREP'
               ){
              this.fullPermission = 1;
            }else {
              this.fullPermission = response.permission.fullPermission;
            }
            



 this.urlUpload = 'https://itaderp.com/script-uploadcompany/dashboard-upload.php?idfolder=' + this.idFolder+'&idowner='+this.identity.sub+'&apikey='+this.apiCompany;
 console.log(this.urlUpload);
// this.urlUpload = sanitizer.bypassSecurityTrustResourceUrl('https://itaderp.com/script-upload/dashboard-upload.php?idfolder=' + this.idFolder);
this.urlUpload = this.sanitizerGlobal.bypassSecurityTrustResourceUrl(this.urlUpload);
 console.log(this.urlUpload);

            
           

           
          
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
        }
        );  
    });
  }

 displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }

   private _filterClientes(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.clientes.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }
    
 getListUsers(type){

console.log("entramos getListUsers");
type="exceptuser";

      this.loading = true;
      this._userService.getAllUsersLite(this.token, type). subscribe(
        response =>{
          //console.log("lite");
        //  console.log(response);
          this.clientes = [];
        //  console.log(this.clientes);
          this.loading = false;
          if(response.status == 'success'){
        

         
               response.data.forEach(function(element) {
           // console.log(element);
           console.log("llenamos clientes getlistusers");
                  this.clientes.push(   {value: element.id, name: element.name + ' ' + element.surname + ' # ' + element.id});

                }.bind(this));
          
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
        }
        );  

  
 
  }

  selectUserPermission(){
    this.loading = true;
  //let userSelected = $("#nameCliente").val();
  //this.folderPermissions.permissions.push(this.folderPermissions.user_id.value);
  let valSend = {
    "idFolder": this.idFolder,
    "idpermiso":this.folderPermissions.user_id.value
  }
 // console.log(valSend);
  //console.log(this.folderPermissions.user_id.value);
  this._folderPermissionService.create(this.token, valSend).subscribe(
      response =>{
        console.log(response);
        if(response.status == 'success'){
          this._folderPermissionService.getFolder(this.token, this.idFolder). subscribe(
        response =>{
          console.log(response);
         
          if(response.status == 'success'){
          
           this.permissions = response.data;

           
          
          } 
        },
        error => {
          console.log(<any>error);
        }
        );  
        
        this.loading = false;
        } else {
          alert(response.msg);
        }
      },
      error => {
        console.log(<any>error);
         alert("Error");
      }
      );

}

ngAfterViewInit(){
$("body").on('change', "select[name='datafolders_length']", function(e){    // 2nd (B)
   let varnew = $( "select[name='datafolders_length']" ).val();
   console.log(varnew);
   localStorage.setItem('psshowuser', varnew);
   });

  
  

}

  

    ngAfterViewChecked() {
     // console.log("ngAfterViewChecked fired!");
    let psshowuser: any = localStorage.getItem("psshowuser")

    if(psshowuser)

    if(!psshowuser){
      psshowuser = 10;
    } 
      
      if(psshowuser <= 1)
        psshowuser = 10;

       this.tableFolder =  $('#datafolders').DataTable({
         "order": [[ 1, "asc" ]],
         dom: 'Bflrtip',
        buttons: [
          /*{
            extend: 'copy',
            exportOptions: {
              columns: ':visible'
            }
          },*//*
          {
            extend: 'csv',
            exportOptions: {
              columns: ':visible'
            }
          },*/
          {
            extend: 'excel',
            text: '<i class="fa fa-file-excel-o"></i>',
            titleAttr: 'Excel',
            className: 'btn btn-sm btn-outline-success',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'pdf',
            text: '<i class="fa fa-file-pdf-o"></i>',
            titleAttr: 'PDF',
            className: 'btn btn-sm btn-outline-danger',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'print',
            text: '<i class="fa fa-print" aria-hidden="true"></i>',
            titleAttr: 'print',
            className: 'btn btn-sm btn-outline-primary',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'colvis',
            text: '<i class="fa fa-columns" aria-hidden="true"></i>',
            className: 'btn btn-sm btn-outline-info',
            titleAttr: 'Column visibility'
          },
        ],
       retrieve: true,
         "pagingType": "full_numbers",
        "lengthMenu": [
          [psshowuser, 10, 25, 50, -1],
          [psshowuser, 10, 25, 50, "All"]
        ],
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search PO#",
        }
      }); 
   


   // console.log(tableFolder);
    /*  if(!tableFolder){
    //    console.log("inicializamosss");
          $('#datafolders').DataTable({
        "pagingType": "full_numbers",
        "lengthMenu": [
          [10, 25, 50, -1],
          [10, 25, 50, "All"]
        ],
        responsive: true,
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search PO#",
        }

      });

        const tableFolder = $('#datafolders').DataTable();

        
      }*/



        const table = $('#datatables').DataTable();
        if(!table){
 $('#datatables').DataTable({
  dom: 'Bflrtip',
  buttons: [
    {
      extend: 'copy',
      exportOptions: {
        columns: ':visible'
      }
    },
    {
      extend: 'csv',
      exportOptions: {
        columns: ':visible'
      }
    },
    {
      extend: 'excel',
      exportOptions: {
        columns: ':visible'
      }
    },
    {
      extend: 'pdf',
      exportOptions: {
        columns: ':visible'
      }
    },
    {
      extend: 'print',
      exportOptions: {
        columns: ':visible'
      }
    },
    'colvis'
  ],
        "pagingType": "full_numbers",
        "lengthMenu": [
          [10, 25, 50, -1],
          [10, 25, 50, "All"]
        ],
        responsive: true,
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search records",
        }

      });

         const table = $('#datatables').DataTable();

      // Delete a file
      table.on('click', '.remove', function(e) {
         e.preventDefault();
          
          var txt;
    var r = confirm("Are you sure to delete this file?");
    if (r == true) {
        const $tr = $(this).closest('tr');
      
        const data = table.row($tr).data();
       // console.log(table);
        table.row($tr).remove().draw();
         $( "#borrarUser" ).val(data[0]);
       
        $( "#borrarUser" ).trigger( "click" );
    } else {
       
    }
        
       
      });
        }


     



    

      $('.card .material-datatables label').addClass('form-group');



    }

    goFolder(folder){
     // console.log(folder);
     // this._router.navigate(['/tables/listfiles', folder]);
     window.location.href='/tables/listcompanyfiles/'+folder;
    }

    upFolder(){
    //  console.log(this.hasparent);
     // this._router.navigate(['/tables/listfiles', folder]);
     if(this.hasparent != 0)
        window.location.href='/tables/listcompanyfiles/'+this.hasparent;
      else 
        this._router.navigate(['/tables/listcompanyfiles']);
    }
}



@Component({
  selector: 'new-foldercompany',
  templateUrl: 'new-folder.html',
  providers: [UserService, FileCompanyService, FolderCompanyService]
})
export class NewSubFoldercompanyFiles implements OnInit {
  public userinterno;
  public tableFolder;
  public loading: boolean = false;
  public identity;
  public token;
  public user: User;
  public status_user;
  public privilegio;
  public pacientes;
  public folder;
  public productosResponse;
  myControl = new FormControl();
  myControlClientes = new FormControl();
  public folderParent;

  public permissionsShow;
   sexos = [
      {value: '1', viewValue: 'Male'},
      {value: '0', viewValue: 'Female'}
    ];

      clientes: UserList[] = [
       
  ];
  
 
   filteredClientes: Observable<UserList[]>;

  
  constructor(
    public dialogRef: MatDialogRef<NewSubFoldercompanyFiles>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _userService: UserService,
   private _fileService: FileCompanyService,
    private _folderService: FolderCompanyService,

      private _route: ActivatedRoute,
      private _router: Router) { 
this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.folder = data;
    console.log(this.folder);

    this.folderParent = data.folderParent;
   // console.log(this.folderParent);
    this.folder.hasparent = this.folderParent;
  //  console.log(data);
    this.loading = true;
   this.folder.permissions = this.folder.permissions || [];
   this.permissionsShow = [];
  // console.log(this.folder.permissions);
  this._userService.getAllUsersLite(this.token,this.folder.folder.companyId). subscribe(
        response =>{
          console.log(response);
          if(response.status == 'success'){
            this.loading = false;
            this.pacientes = [];
               //this.clientes = null;
               response.data.forEach(function(element) {
           
                  this.pacientes.push(   {value: element.id, name: element.name + ' ' + element.surname + ' # ' + element.id});

                }.bind(this));


          
        
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
        }
        ); 
  }

  ngOnInit(){
    console.log("empezamos");
       this.tableFolder = $('#datafolders').DataTable();
     
        this.tableFolder.destroy();


   console.log(this.clientes);
    if(this.identity == null && this.identity.sub){
      this._router.navigate(['/pages/lock']);
    } else {
      
    }


    this.getListUsers(this.folder.folder.companyId);

    this.filteredClientes = this.myControlClientes.valueChanges
      .pipe(
        startWith<string | UserList>(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filterClientes(name) : this.pacientes.slice())
      );

     console.log("terminamos");



  }

  displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }

   private _filterClientes(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.pacientes.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

     getListUsers(type){
type= 'exceptuser';

console.log(type);
      this.loading = true;
      this._userService.getAllUsersLite(this.token, type). subscribe(
        response =>{
         // console.log("lite");
         // console.log(response);
          this.pacientes = [];
          this.loading = false;
          if(response.status == 'success'){
          

          
              //this.clientes = null;
               response.data.forEach(function(element) {
           
                  this.pacientes.push(   {value: element.id, name: element.name + ' ' + element.surname + ' # ' + element.id});

                }.bind(this));
              // console.log(this.pacientes);
          
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);

          }
        },
        error => {
          console.log(<any>error);
        }
        );  

  
 
  }
 

  selectPacient(event){
  //console.log(event.value);

  
      this._userService.getUser(this.token, event.value).subscribe(
        response => {
          
          if(response.status == 'success'){
           
              this.userinterno = response.data;
              console.log(this.userinterno);
            this.folder.user_id = this.userinterno.id;
         
          } 
        },
        error => {
          console.log(<any>error);
        }
      );
  
   
}


selectUserPermission(){
  let userSelected = $("#nameCliente").val();

 
  this.folder.permissions.push(this.folder.user_id.value);
  this.permissionsShow.push(this.folder.user_id.name+'');
  console.log(this.folder);

}

addItem(){
  console.log("add item");
}

  onNoClick(): void {
   

  }

}

